import { useAuthContext } from "@/context/Auth";
import { AvatarProps, Avatar as MantineAvatar } from "@mantine/core";
import Image from "next/image";

export default function Avatar(props: AvatarProps) {
  const { state: { twoFactorAuthenticated } } = useAuthContext();

  return (
    <>
      {twoFactorAuthenticated && <MantineAvatar {...props} />}
      {!twoFactorAuthenticated && (
        <Image
          src="/img/user.png"
          alt="Placeholder Profile Image"
          width={48}
          height={48}
          style={{ marginRight: "16px" }}
        />
      )}
    </>
  );
}
